module.exports = __webpack_public_path__ + "static/Checkmate-f3872b6800c0fcd99b6c43d1a89e5b41.jpg";